export enum PlatformCoreFragments {
    Carrier = 'Carrier',
    Customer = 'Customer',
    Vendor = 'Vendor',
    Location = 'Location',
}
